import {
	AfterViewInit,
	Component
}												from '@angular/core'
import {
	ConfigService,
	StateService
}												from '../../'
import { TermsConfig }	from '../../'

declare var document: any

@Component({
  selector:			'electra-terms',
  styleUrls:		[ './terms.component.scss' ],
  templateUrl:	'./terms.component.html'
})
export class TermsComponent implements AfterViewInit {
	config:		TermsConfig
	content:	any

  constructor(public configService: ConfigService, private stateService: StateService) {
		configService.terms.subscribe(data => { this.gotConfig(data) })
	}

	closeClick() {
		this.stateService.state = 'more';
	}

	ngAfterViewInit() {
		this.content = document.getElementById('terms-content')
	}

	gotConfig(config: TermsConfig) {
		this.config = config
		
		if (typeof this.content !== 'undefined' && typeof config.content !== 'undefined') {
			this.content.innerHTML = '<style>* {font-family:Roboto;}</style>' + config.content
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/terms/terms.component.ts